import type { ComponentType } from 'react';
import type { RouteObject } from 'react-router';

/** apps/web が集約する。ルート単位で遅延ロード（03 第 I 部 §2） */
type PageModule = { default: ComponentType };

function page(load: () => Promise<PageModule>): RouteObject['lazy'] {
  return async () => {
    const m = await load();
    return { Component: m.default };
  };
}

export const projectRoutes: RouteObject[] = [
  { path: '/project', lazy: page(() => import('./pages/ProjectListPage.js')) },
  { path: '/project/new', lazy: page(() => import('./pages/ProjectFormPage.js')) },
  { path: '/project/projects/:id', lazy: page(() => import('./pages/ProjectDetailPage.js')) },
  { path: '/project/projects/:id/edit', lazy: page(() => import('./pages/ProjectFormPage.js')) },
  { path: '/project/timesheets', lazy: page(() => import('./pages/TimesheetPage.js')) },
  { path: '/project/alerts', lazy: page(() => import('./pages/ProjectAlertsPage.js')) },
  { path: '/project/costs/import', lazy: page(() => import('./pages/CostImportPage.js')) },
];
